import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CREATE_VEHICLE, CREATE_VEHICLE_SUCCESS, CREATE_VEHICLE_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* createVehicle({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/vehicles`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CREATE_VEHICLE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_VEHICLE_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_VEHICLE_ERROR, payload: error });
  }
}

export function* watchCreateVehicle() {
  yield takeEvery(CREATE_VEHICLE, createVehicle);
}

function* createVehicleSaga() {
  yield all([fork(watchCreateVehicle)]);
}

export default createVehicleSaga;
